export const status = {
  notApproved: 'notApproved',
  approved: 'approved',
  declined: 'declined',
  excluded: 'excluded',
};

export const status_ru = {
  notApproved: 'Не утверждена',
  approved: 'Утверждена',
  declined: 'Отклонена',
  excluded: 'Исключена',
};

export const state = {
  onProj: 'onProj',
  onProjReturned: 'onProjReturned',
  onProjNewVersion: 'onProjNewVersion',
  onPortf: 'onPortf',
  onStrat: 'onStrat',
  onStratReturned: 'onStratReturned',
  onSecy: 'onSecy',
  onExpert: 'onExpert',
  none: null,
};

export const state_ru = {
  onProj: 'Введена руководителем проекта',
  onProjReturned: 'На доработке у руководителя проекта',
  onProjNewVersion: 'На доработке у руководителя проекта',
  onPortf: 'На согласовании у руководителя Портфеля',
  onStrat: 'На согласовании у руководителя СП',
  onStratReturned: 'На доработке у руководителя стратегического проекта',
  onPolicy: 'На согласовании у руководителя политики',
  onPolicyReturned: 'На доработке у руководителя политики',
  onGoal: 'На согласовании у руководителя цели',
  onGoalReturned: 'На доработке у руководителя цели',
  onTech: 'На согласовании у руководителя СТП',
  onTechReturned: 'На доработке у руководителя стратегического технологического проекта',
  onSecy: 'У секретаря',
  onExpert: 'На рассмотрении комиссии',
  none: '',
};

export const status_full = {
  notApproved: { key: status.notApproved, label: status_ru.notApproved, bg: 'secondary' },
  approved: { key: status.approved, label: status_ru.approved, bg: 'success' },
  declined: { key: status.declined, label: status_ru.declined, bg: 'danger' },
  excluded: { key: status.excluded, label: status_ru.excluded, bg: 'secondary' },
};

export const state_full = {
  onProj: { key: state.onProj, label: state_ru.onProj, bg: 'secondary' },
  onProjReturned: { key: state.onProjReturned, label: state_ru.onProjReturned, bg: 'danger' },
  onProjNewVersion: { key: state.onProjNewVersion, label: state_ru.onProjNewVersion, bg: 'secondary' },
  onPortf: { key: state.onStrat, label: state_ru.onPortf, bg: 'warning' },
  onStrat: { key: state.onStrat, label: state_ru.onStrat, bg: 'warning' },
  onStratReturned: { key: state.onStratReturned, label: state_ru.onStratReturned, bg: 'danger' },
  onPolicy: { key: state.onStrat, label: state_ru.onPolicy, bg: 'warning' },
  onPolicyReturned: { key: state.onStratReturned, label: state_ru.onPolicyReturned, bg: 'danger' },
  onGoal: { key: state.onStrat, label: state_ru.onGoal, bg: 'warning' },
  onGoalReturned: { key: state.onStratReturned, label: state_ru.onGoalReturned, bg: 'danger' },
  onTech: { key: state.onStrat, label: state_ru.onTech, bg: 'warning' },
  onTechReturned: { key: state.onStratReturned, label: state_ru.onTechReturned, bg: 'danger' },
  onSecy: { key: state.onSecy, label: state_ru.onSecy, bg: 'warning' },
  onExpert: { key: state.onExpert, label: state_ru.onExpert, bg: 'warning' },
  none: { key: state.none, label: state_ru.none, bg: '' },
};
